
import './CompteClientDocCommerciaux.scss';

//import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { API_SERVER_FILES } from '../../../config';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, getTimeFromIsoFormatDate, SpliUrl } from '../../../Utils/utils';
//import { useState } from 'react';
import SideBar from './SideBarGestionClient';

//import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';
function DocumentsCommerciaux() {
    // const { state } = useLocation();
    //const axiosPrivate = useAxiosPrivate();

    const axiosPrivate = useAxiosPrivate();
    let param = useParams();
    const [docCommerciaux,setDocCommerciaux]=useState([]);
    const [nomEntreprise,setNomEntreprise]=useState('');
    const {device}=useWindowSize();
    const { i18n } = useTranslation();

    useEffect(() => {
        getClientbyId();
    }, []);

    const getClientbyId = async () => {
        try {
            let endpoint = location.pathname.includes('gestionEsn') ? '/users/getDocsEsnById/':'/users/getDocsClientById/';
            const response = await axiosPrivate.get(endpoint+(param.ClientId ?? param.EsnId));
            setDocCommerciaux(response?.data?.docsCommerciaux.reverse());
            setNomEntreprise(response?.data?.profileEntreprise?.nom);
            console.log('dataa',response.data);
        }catch (error){
            console.log(error);
        }
    };

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{location?.pathname?.includes('gestionEsn')  ? i18n.t('Gestion des Esn'):i18n.t('Gestion des Clients')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{nomEntreprise} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <SideBar/>
                    <div className='frame0DocCommerciaux'>
                        <div className='frame1DocCommerciaux'>
                            <div className='frame2DocCommerciaux'>
                                <h5 className='frame3DocCommerciaux'>
                                    {i18n.t('Documents commericiaux')}
                                </h5>
                            </div>
                            {docCommerciaux.map((x, i) => (
                                <div
                                    style={{display:'flex',width:device=='desktop'?'80%':'100%',minWidth:device=='desktop'?'514px':'200px',alignSelf:'center'}}
                                    key={i}
                                >
                                    <div
                                        className='frame4DocCommerciaux'
                                    >
                                        <div className='frame5DocCommerciaux'>
                                            <div className='frame6DocCommerciaux'>
                                                <div className='frame7DocCommerciaux'>
                                                    <div className='frame8DocCommerciaux'>
                                                        <svg
                                                            width="19"
                                                            height="25"
                                                            viewBox="0 0 19 25"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M17.1926 4.65625L13.677 1.14062C13.1145 0.578125 12.3645 0.25 11.5676 0.25H3.08325C1.39575 0.25 0.083252 1.60938 0.083252 3.25V21.25C0.083252 22.9375 1.39575 24.25 3.08325 24.25H15.0833C16.7239 24.25 18.0833 22.9375 18.0833 21.25V6.76562C18.0833 5.96875 17.7551 5.21875 17.1926 4.65625ZM15.8333 21.25C15.8333 21.6719 15.4583 22 15.0833 22H3.08325C2.66138 22 2.33325 21.6719 2.33325 21.25V3.29688C2.33325 2.875 2.66138 2.54688 3.08325 2.54688H10.5833V6.25C10.5833 7.09375 11.2395 7.75 12.0833 7.75H15.7864V21.25H15.8333ZM9.552 13.7031C9.552 13.5625 9.59888 13.4219 9.64575 13.2812C9.7395 13.0469 10.0208 11.8281 10.0208 10.8438C10.0208 9.95312 9.31763 9.25 8.427 9.25C7.58325 9.25 6.88013 9.95312 6.88013 10.8438C6.88013 10.8438 6.88013 12.2031 7.4895 13.75C7.16138 14.6875 6.78638 15.5781 6.31763 16.4688C5.33325 16.9375 4.4895 17.5 3.83325 18.1562C3.552 18.4844 3.41138 18.8594 3.41138 19.3281C3.41138 20.1719 4.1145 20.875 4.95825 20.875C5.47388 20.875 5.94263 20.6406 6.27075 20.2188C6.59888 19.75 7.1145 19 7.677 17.9688C8.427 17.6406 9.27075 17.4062 10.2083 17.2188C10.8176 17.6406 11.5676 18.0156 12.3645 18.25C12.552 18.3438 12.7864 18.3906 13.0208 18.3906C13.9583 18.3906 14.7083 17.6406 14.7083 16.6562C14.7083 15.7188 13.9583 14.9219 12.9739 14.9219H12.8333C12.6926 14.9219 11.8489 14.9688 10.677 15.1562C10.2083 14.7344 9.83325 14.2656 9.552 13.7031ZM5.2395 19.5156C5.052 19.75 4.677 19.6562 4.677 19.2812C4.677 19.1875 4.677 19.0938 4.72388 19.0469C5.14575 18.625 5.66138 18.25 6.22388 17.9219C5.802 18.7188 5.427 19.2344 5.2395 19.5156ZM8.427 10.5156C8.6145 10.5156 8.75513 10.6562 8.75513 10.8438C8.75513 11.5469 8.56763 12.4844 8.47388 12.8125C8.14575 11.7344 8.09888 10.9375 8.09888 10.8438C8.09888 10.6562 8.2395 10.5156 8.427 10.5156ZM7.677 16.6094C7.95825 15.9531 8.28638 15.25 8.56763 14.5C8.89575 15.0156 9.27075 15.5312 9.7395 16C9.08325 16.1406 8.38013 16.3281 7.677 16.6094ZM12.8333 16.1875H12.9739C13.2551 16.1875 13.4426 16.375 13.4426 16.7031C13.4426 16.9375 13.2551 17.125 13.0208 17.125C12.927 17.125 12.8333 17.125 12.7395 17.0781C12.177 16.8906 11.6614 16.6562 11.2395 16.375C12.177 16.2344 12.8333 16.1875 12.8333 16.1875Z"
                                                                fill="#272D3C"
                                                            />
                                                        </svg>

                                                    </div>
                                                    <a
                                                        href={API_SERVER_FILES+ x?.url}
                                                        className='frame9DocCommerciaux'
                                                        target='_blank'
                                                        rel="noreferrer"
                                                    >
                                                        {SpliUrl(x?.url)}
                                                    </a>
                                                </div>
                                                <p className='frame10DocCommerciaux'>{i18n.t('Téléchargé par')} {getNomPrenomClearFromPersoData(x?.collaboratorId?.persoData ?? x?.collaboratorEsnId?.persoData)} {i18n.t('le')} {formatDateJJMMYYYY(x?.createdAt)} {i18n.t('à')} {getTimeFromIsoFormatDate(x?.createdAt)}</p>
                                            </div>
                                            <div className='frame11DocCommerciaux'>
                                                {/*PS: doc commerciaux n'ont pas un statut*/}
                                            </div>
                                        </div>
                                        <div className='frame16DocCommerciaux'>
                                            <div className='frame9Kbis'>
                                                {/*//date d'aujourdhuit - date d l'extrait*/}
                                                <p className='frame10Kbis'>
                                                    {i18n.t('Type')}: {x?.type}
                                                </p>
                                            </div>
                                            {x?.missionId &&
                                            <div className='frame14Kbis'>
                                                <p className='frame10Kbis'>
                                                    {i18n.t('Réf mission')}: {x?.missionId}
                                                </p>
                                            </div>}
                                        </div>
                                        {/*<div className='frame17DocCommerciaux'>
                                            <label className='frame18DocCommerciaux'>Type : {x?.collaboratorId?.type}</label>
                                        </div>
                                        <div className='frame20DocCommerciaux'>
                                            <label className='frame18DocCommerciaux'>Réf.mission : {x?.collaboratorId?.missionId}</label>
                                        </div>
                                    </div>*/}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default DocumentsCommerciaux;